<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Necessidade de Compra #{{ dados?.numero }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-listar-necessidades-solicitante' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="q-ml-md">
      <section class="column text-brand-5 text-weight-bold">
        <span
          style="font-size: 16px"
          v-if="dados && dados.cod_integracao != null"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Criado por:</span>

          <span
            v-if="!editarCabecalho"
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
          >
            {{ dados?.usuario_nome }}
          </span>
          <q-input
            v-else
            dense
            v-model="dados.usuario_nome"
            outlined
            class="q-ml-sm"
            style="font-size: 12px"
          />
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Urgência Definida:</span>

          <span
            v-if="!editarCabecalho"
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
          >
            {{ dados?.tag }}
          </span>
          <q-input
            v-else
            dense
            v-model="dados.tag"
            outlined
            class="q-ml-sm"
            style="font-size: 12px"
          />
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Solicitante:</span>

          <span
            v-if="!editarCabecalho"
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
          >
            {{ dados?.solicitante_nome }}
          </span>
          <q-input
            v-else
            dense
            v-model="dados.solicitante_nome"
            outlined
            class="q-ml-sm"
            style="font-size: 12px"
          />
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Unidade de Controle:</span>

          <span
            v-if="!editarCabecalho"
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
          >
            {{ dados?.cost_center_code }} ({{ dados?.cost_center_name }})
          </span>

          <div v-else class="row">
            <q-input
              dense
              v-model="dados.cost_center_code"
              outlined
              class="q-ml-sm"
              style="width: 70px"
            />
            <q-input
              dense
              v-model="dados.cost_center_name"
              outlined
              class="q-ml-sm"
            />
          </div>
        </span>

        <span
          v-if="dados?.created_at"
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Criada Em:</span>

          <span
            v-if="!editarCabecalho"
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
          >
            {{ dados?.created_at.split(" ")[0].split("-").reverse().join("/") }}
          </span>
          <q-input
            v-else
            dense
            v-model="dados.created_at"
            outlined
            class="q-ml-sm"
            type="date"
          />
        </span>

        <span class="q-mt-sm text-brand-5 text-weight-bold row items-center">
          <span style="font-size: 16px" class="text-brand-1">
            <div v-if="dados?.voucher_id">
              Esta necessidade também gerou a requisição:
              <a
                class="target"
                @click="rota('requisicao-detalhe', dados?.voucher_id)"
                rel="noopener noreferrer"
              >
                {{ dados?.voucher_id }}
              </a>
            </div>

            <span class="text-brand-1" v-else>
              Esta necessidade não tem requisição vinculada.
            </span>
          </span>
        </span>

        <div class="q-mt-md row items-center no-wrap">
          <div class="row items-center">
            <q-btn
              v-if="!editarCabecalho"
              no-caps
              icon="list"
              label="Dados Auxiliares"
              style="
                border-radius: 8px;
                background-color: #304f78;
                color: white;
              "
              @click="modalNecessidadeBase = true"
            />
            <div v-else class="row items-center">
              <q-btn
                no-caps
                icon="check"
                label="Confirmar"
                class="q-ml-sm"
                style="
                  border-radius: 8px;
                  background-color: green;
                  color: white;
                "
                @click="confirmarEdicaoCabecalho"
              />
              <q-btn
                no-caps
                icon="close"
                label="Cancelar"
                class="q-ml-sm"
                style="border-radius: 8px; background-color: red; color: white"
                @click="editarCabecalho = false"
              />
            </div>
          </div>

          <q-btn
            v-if="!editarCabecalho"
            no-caps
            icon="history"
            label="Histórico necessidade"
            class="q-ml-sm self-center"
            style="border-radius: 8px; background-color: #21324a; color: white"
            @click="abrirHistoricoNecessidade"
          />
        </div>
      </section>
    </div>

    <ProdutosNecessidadeManual
      :data="itens"
      :info="info"
      @atualizar="atualizar"
      :get="get"
    />

    <div class="row col-12 align q-mt-md">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span> Arquivos da Necessidade </span>
      </div>
    </div>
    <section class="row align q-ml-md">
      <div class="col-2 row items-center">
        <div>
          <q-file label="Selecione o Arquivo" outlined dense v-model="file">
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>
      </div>

      <div>
        <q-btn
          no-caps
          icon="done"
          label="Enviar Arquivo"
          class="q-ml-sm"
          style="border-radius: 8px; background-color: #21324a; color: white"
          @click="enviarTemplate"
        />
      </div>
      <div>
        <q-btn
          no-caps
          class="q-ml-sm"
          icon="attach_file"
          label="Ver Arquivos"
          style="border-radius: 8px; background-color: #304f78; color: white"
          @click="getDocumentos"
        />
      </div>
    </section>

    <div v-if="dados?.observacao" class="row col-12 align q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span> Observações </span>
      </div>
    </div>
    <section v-if="dados?.observacao" class="row align q-ml-md q-mt-sm">
      <div class="col-12">
        <q-input
          v-model="dados.observacao"
          dense
          outlined
          type="textarea"
          readonly
          class="input-observacoes"
          bg-color="grey-2"
          :rows="4"
        />
      </div>
    </section>

    <q-dialog v-model="documentos">
      <q-card style="width: 800px; max-width: 80vw; height: 80%">
        <q-card-section class="row justify-center">
          <div class="text-h6 text-brand-1 text-weight-bold">
            Documentos Enviados
          </div>
        </q-card-section>
        <q-separator />
        <ul class="col-12">
          <li
            class="text-brand-5"
            v-for="(documento, index) in listaDocumentos"
            :key="index"
          >
            <div class="row col-12 justify-between items-center q-mx-md">
              <div class="text-brand-1 text-weight-bold">
                {{ `Documento ${index + 1}` }}
              </div>
              <div>
                <q-btn
                  :href="documento.url"
                  round
                  flat
                  icon="sym_o_download"
                  style="color: #21324a"
                >
                  <q-tooltip>Baixar Documento</q-tooltip>
                </q-btn>

                <q-btn
                  dense
                  no-caps
                  flat
                  round
                  icon="sym_o_delete"
                  color="negative"
                  @click="deletarDocumento(documento.uuid)"
                >
                  <q-tooltip>Excluir Documento</q-tooltip>
                </q-btn>
              </div>
            </div>
          </li>
        </ul>
      </q-card>
    </q-dialog>

    <q-dialog v-model="historicoDialog">
      <q-card class="modal-ativos" style="min-width: 80vw">
        <q-card-section>
          <div class="text-h6 text-brand-1 text-weight-bold">
            Histórico de Edições da Necessidade
          </div>
        </q-card-section>

        <q-card-section class="scroll">
          <q-linear-progress
            v-if="historicoCarregando"
            indeterminate
            size="3px"
          />

          <q-table
            flat
            :columns="columnsHistorico"
            :rows="historicoItens"
            row-key="editado_em"
            dense
            :rows-per-page-options="[0]"
            no-data-label="Nenhum histórico encontrado."
            class="my-sticky-dynamic-ativo"
            hide-bottom
          >
            <template v-slot:body-cell-verDados="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <q-btn
                  no-caps
                  icon="sym_o_visibility"
                  round
                  class="q-ml-sm"
                  @click="inserirDados(props.row)"
                  style="background-color: #304f78; color: white"
                />
              </q-td>
            </template>
          </q-table>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Fechar" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <dialog-info-design
      class="row col-12"
      :mensagem="`Dados Auxiliares - Necessidade: ${dadosAuxiliares?.necessidade_numero}`"
      :subMensagem="`Editado em: ${dadosAuxiliares?.editado_em}, Editado por: ${dadosAuxiliares?.editado_por?.nome}, Matricula: ${dadosAuxiliares?.editado_por?.matricula}`"
      :showConteudo="true"
      :width="'800px'"
      :exibir="modalNecessidade"
      @resultado="modalNecessidade = false"
    >
      <section class="row">
        <div style="width: 49%">
          <span style="font-size: 16px" class="text-brand-1 text-bold"
            >Valores Iniciais</span
          >
          <div>
            <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
            <q-input
              class="input-new-design"
              dense
              outlined
              v-model="dadosAuxiliares.valor_inicial.data_aplicacao"
              readonly
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="dadosAuxiliares.valor_inicial.data_aplicacao"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Justificativa Contratação *
            </div>
            <q-input
              v-model="dadosAuxiliares.valor_inicial.justificativa_contratacao"
              dense
              type="textarea"
              outlined
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
            <q-input
              v-model="dadosAuxiliares.valor_inicial.detalhamento_tecnico"
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Responsabilidades Fornecedores
            </div>
            <q-input
              v-model="
                dadosAuxiliares.valor_inicial.responsabilidades_fornecedores
              "
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Responsabilidades Contratante
            </div>
            <q-input
              v-model="
                dadosAuxiliares.valor_inicial.responsabilidades_contratante
              "
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
            <q-input
              v-model="dadosAuxiliares.valor_inicial.possiveis_fornecedores"
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
        </div>
        <div class="q-ml-sm" style="width: 49%">
          <span style="font-size: 16px" class="text-brand-1 text-bold"
            >Valores Finais</span
          >
          <div>
            <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
            <q-input
              class="input-new-design"
              dense
              outlined
              v-model="dadosAuxiliares.valor_final.data_aplicacao"
              readonly
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="dadosAuxiliares.valor_final.data_aplicacao"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Justificativa Contratação *
            </div>
            <q-input
              v-model="dadosAuxiliares.valor_final.justificativa_contratacao"
              dense
              type="textarea"
              outlined
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
            <q-input
              v-model="dadosAuxiliares.valor_final.detalhamento_tecnico"
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Responsabilidades Fornecedores
            </div>
            <q-input
              v-model="
                dadosAuxiliares.valor_final.responsabilidades_fornecedores
              "
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">
              Responsabilidades Contratante
            </div>
            <q-input
              v-model="
                dadosAuxiliares.valor_final.responsabilidades_contratante
              "
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
          <div>
            <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
            <q-input
              v-model="dadosAuxiliares.valor_final.possiveis_fornecedores"
              dense
              outlined
              type="textarea"
              class="input input-new-design"
              readonly
            />
          </div>
        </div>
      </section>
    </dialog-info-design>
    <dialog-info-design
      class="row col-12"
      mensagem="Detalhes Necessidade Compra"
      subMensagem="Os dados abaixo são para complementar os dados para auxiliar no processo de compras."
      :showConteudo="true"
      :width="'800px'"
      :exibir="modalNecessidadeBase"
      :desabilitarConfirme="
        dadosAuxiliaresBase.data_aplicacao == '' ||
        dadosAuxiliaresBase.justificativa_contratacao == '' ||
        !validarDataAplicacao(dadosAuxiliaresBase.data_aplicacao)
      "
      @resultado="alterarDadosAuxiliares"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="dadosAuxiliaresBase.data_aplicacao"
          mask="##/##/####"
          :rules="[
            (val) => val || 'Campo obrigatório',
            (val) =>
              validarDataAplicacao(val) ||
              'Data deve ser igual ou posterior a hoje',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dadosAuxiliaresBase.data_aplicacao"
                  :options="opcoesDataCalendario"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Justificativa Contratação *
        </div>
        <q-input
          v-model="dadosAuxiliaresBase.justificativa_contratacao"
          dense
          type="textarea"
          outlined
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
        <q-input
          v-model="dadosAuxiliaresBase.detalhamento_tecnico"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Fornecedores
        </div>
        <q-input
          v-model="dadosAuxiliaresBase.responsabilidades_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Contratante
        </div>
        <q-input
          v-model="dadosAuxiliaresBase.responsabilidades_contratante"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
        <q-input
          v-model="dadosAuxiliaresBase.possiveis_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
const columnsHistorico = [
  {
    name: "data_edicao",
    label: "Data Edição",
    align: "left",
    field: (row) => row.editado_em,
  },
  {
    name: "usuario",
    label: "Usuário Editor",
    align: "left",
    field: (row) => `${row.editado_por.nome} (${row.editado_por.matricula})`,
  },

  {
    name: "verDados",
    label: "Dados Auxiliares",
    align: "left",
    field: (row) => row.valor_final.verDados,
  },
];

import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import ProdutosNecessidadeManual from "../components/ProdutosNecessidadeManual.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  components: { ProdutosNecessidadeManual, DialogInfoDesign },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const produtosSemReferencia = ref([]);
    const itens = ref([]);
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const documentos = ref(false);
    const file = ref("");
    const disable = ref(true);
    const id = route.params.id;
    const dados = ref();
    const info = ref("");
    const modalNecessidade = ref(false);
    const modalNecessidadeBase = ref(false);
    const get = ref(0);
    const listaDocumentos = ref([]);
    let dadosAuxiliaresBase = ref({
      data_aplicacao: "",
      detalhamento_tecnico: "",
      justificativa_contratacao: "",
      responsabilidades_contratante: "",
      responsabilidades_fornecedores: "",
      possiveis_fornecedores: "",
    });
    const dadosAuxiliares = ref({
      necessidade_id: "",
      valor_inicial: {
        detalhamento_tecnico: "",
        justificativa_contratacao: "",
        responsabilidades_contratante: "",
        responsabilidades_fornecedores: "",
        possiveis_fornecedores: "",
      },
      valor_final: {
        detalhamento_tecnico: "",
        justificativa_contratacao: "",
        responsabilidades_contratante: "",
        responsabilidades_fornecedores: "",
        possiveis_fornecedores: "",
      },
    });
    const editarCabecalho = ref(false);
    const dadosOriginais = ref(null);
    const historicoDialog = ref(false);
    const historicoCarregando = ref(false);
    const historicoItens = ref([]);
    const historicoErro = ref(null);

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/acompanhar", {
          uuid: id,
        });

        dados.value = await response.data?.data[0];

        if (dados.value?.cod_integracao === null) {
          dados.value.cod_integracao = "";
        }
        dadosAuxiliaresBase.value = {
          ...dados.value,
          data_aplicacao: dados.value.data_aplicacao
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/"),
        };

        rows.value = response.data.data;

        if (rows.value.length == 0) {
          rows.value = produtosSemReferencia.value;
          dados.value = produtosSemReferencia.value[0];
        }

        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const confirmarEdicaoCabecalho = async () => {
      try {
        if (!dados.value?.uuid) {
          throw new Error("UUID da necessidade não encontrado");
        }

        if (
          !dados.value.tag ||
          !dados.value.solicitante_nome ||
          !dados.value.cost_center_code
        ) {
          throw new Error("Preencha todos os campos obrigatórios");
        }

        await store.dispatch("comprasSolicitante/setEditarCabecalho", {
          uuid: dados.value.uuid,
          numero: dados.value.numero,
          usuario_nome: dados.value.usuario_nome,
          tag: dados.value.tag,
          solicitante_nome: dados.value.solicitante_nome,
          cost_center_code: dados.value.cost_center_code,
          cost_center_name: dados.value.cost_center_name,
          created_at: dados.value.created_at,
        });

        editarCabecalho.value = false;
        $q.notify({
          message: "Cabeçalho atualizado com sucesso!",
          color: "positive",
        });

        await getDados();
      } catch (error) {
        console.error("Erro ao editar cabeçalho:", error);
        $q.notify({
          message:
            error.response?.data?.message ||
            error.message ||
            "Erro ao atualizar cabeçalho",
          color: "negative",
        });
      }
    };

    watch(editarCabecalho, (newVal) => {
      if (newVal) {
        dadosOriginais.value = JSON.parse(JSON.stringify(dados.value));
      } else if (dadosOriginais.value) {
        dados.value = JSON.parse(JSON.stringify(dadosOriginais.value));
      }
    });

    const setScNumero = async () => {
      try {
        const response = await store.dispatch("compras/setScNumero", {
          uuid: id,
          cod_integracao: dados.value.cod_integracao,
          observacao: dados.value.observacao,
        });
        info.value = response.data.result;

        itens.value = response.data.result.itens.products;
      } catch (error) {
        $q.notify({
          message: "Erro ao adicionar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getSemReferencia = async () => {
      try {
        const response = await store.dispatch("compras/getSemReferencia", {
          uuid: id,
        });

        produtosSemReferencia.value = await response.data.data;

        if (
          dados.value &&
          dados.value != "" &&
          produtosSemReferencia.value.length != 0
        ) {
          dados.value = await response.data.data[0];
          if (dados.value?.cod_integracao == null) {
            dados.value.cod_integracao = "";
          }
        }

        disable.value = false;
        getDados();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar produtos sem referencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getSemReferencia);

    const deletar = async (uuid) => {
      try {
        await store.dispatch("compras/deletarSemReferencia", {
          uuid: id,
          uuid_itens: [uuid],
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getSemReferencia();
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async (dados) => {
      if (dados.codigo) {
        try {
          await store.dispatch("compras/editarSemReferenciaCodigo", {
            uuid: id,
            produtos: [
              {
                produto_fora_catalogo_uuid: dados.uuid_item_fora_catalogo,
                codigo: dados.codigo,
              },
            ],
          });
          get.value++;
          $q.notify({
            message: "Código Vinculado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getSemReferencia();
          getDados();
        } catch (error) {
          dados.codigo = "";
          $q.notify({
            message: "Código inválido!!",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }

      let item = {
        responsavel_id: dados.usuario?.id,
        cost_center_code: dados.item_cost_center_code?.code,
        quantidade: dados.quantidadeNecessaria,
      };

      if (
        item.responsavel_id != undefined ||
        item.responsavel_id != null ||
        item.quantidade != undefined
      ) {
        try {
          await store.dispatch("compras/editarSemReferencia", {
            uuid: dados.uuid_item_fora_catalogo,
            need_id: id,
            item: item,
          });

          $q.notify({
            message: "Editado com sucesso!",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getSemReferencia();
          getDados();
        } catch (error) {
          $q.notify({
            message:
              "Erro ao editar, o nome do responsável precisa ser o Número",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const abrirHistoricoNecessidade = async () => {
      try {
        historicoDialog.value = true;
        historicoCarregando.value = true;
        historicoErro.value = null;

        const response = await store.dispatch(
          "comprasSolicitante/getHistoricoNecessidade",
          { necessidadeId: id }
        );

        historicoItens.value = response;

        historicoItens.value.sort((a, b) => {
          const [diaA, mesA, anoHoraA] = a.editado_em.split("/");
          const [anoA, horaA] = anoHoraA.split(" ");
          const dataA = new Date(`${anoA}-${mesA}-${diaA}T${horaA}`);

          const [diaB, mesB, anoHoraB] = b.editado_em.split("/");
          const [anoB, horaB] = anoHoraB.split(" ");
          const dataB = new Date(`${anoB}-${mesB}-${diaB}T${horaB}`);

          return dataB - dataA; // Mais recente primeiro
        });
      } catch (error) {
        console.error("Erro detalhado:", error);
        historicoErro.value =
          error.response?.data?.message || "Erro ao carregar histórico";
      } finally {
        historicoCarregando.value = false;
      }
    };

    const formatarData = (dataString) => {
      if (!dataString) return "-";

      let data = new Date(dataString);
      if (isNaN(data.getTime())) {
        const match =
          /^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(
            dataString
          );
        if (match) {
          const [, dia, mes, ano, hora = "00", min = "00", seg = "00"] = match;
          data = new Date(`${ano}-${mes}-${dia}T${hora}:${min}:${seg}`);
        }
      }
      if (isNaN(data.getTime())) return "Data Inválida";
      return (
        data.toLocaleDateString("pt-BR") +
        " " +
        data.toLocaleTimeString("pt-BR")
      );
    };

    const rota = async (rota, param = "") => {
      router.push({
        name: rota,
        params: { requisicaoId: param },
      });
    };

    const atualizar = async () => {
      getDados();
      getSemReferencia();
    };

    const inserirDados = (dados) => {
      modalNecessidade.value = true;
      dadosAuxiliares.value = { ...dados };
      dadosAuxiliares.value.valor_inicial.data_aplicacao =
        dadosAuxiliares.value?.valor_inicial?.data_aplicacao
          ?.split(" ")[0]
          ?.split("-")
          ?.reverse()
          ?.join("/");
      dadosAuxiliares.value.valor_final.data_aplicacao =
        dadosAuxiliares.value?.valor_final?.data_aplicacao
          ?.split(" ")[0]
          ?.split("-")
          ?.reverse()
          ?.join("/");
    };

    const obterDiasLimitePorUrgencia = (urgencia) => {
      const urgenciaLower = urgencia?.toLowerCase();
      if (urgenciaLower === "normal") return 15;
      if (urgenciaLower === "urgente") return 10;
      if (
        urgenciaLower === "maquina parada" ||
        urgenciaLower === "máquina parada"
      )
        return 7;
      return 15;
    };

    const calcularDataMinima = () => {
      if (!dados.value?.tag || !dados.value?.created_at) return null;

      const dataString = dados.value.created_at.split(" ")[0];
      const [ano, mes, dia] = dataString.split("-");

      const dataCriacao = new Date(
        parseInt(ano),
        parseInt(mes) - 1,
        parseInt(dia)
      );
      const diasLimite = obterDiasLimitePorUrgencia(dados.value.tag);

      const dataMinima = new Date(dataCriacao);
      dataMinima.setDate(dataMinima.getDate() + diasLimite);

      return dataMinima;
    };

    const calcularDataMaxima = () => {
      if (!dados.value?.created_at || !dados.value?.tag) return null;

      const dataCriacao = new Date(dados.value.created_at.split(" ")[0]);
      const diasLimite = obterDiasLimitePorUrgencia(dados.value.tag);

      const dataMaxima = new Date(dataCriacao);
      dataMaxima.setDate(dataMaxima.getDate() + diasLimite);

      return dataMaxima;
    };

    const validarDataAplicacao = (data) => {
      if (!data) return true;

      const [diaData, mesData, anoData] = data.split("/");
      const dataEscolhida = new Date(anoData, mesData - 1, diaData);
      dataEscolhida.setHours(0, 0, 0, 0);

      const dataMinima = calcularDataMinima();
      if (dataMinima) {
        dataMinima.setHours(0, 0, 0, 0);
        if (dataEscolhida < dataMinima) return false;
      }

      return true;
    };

    const converterDataParaQDate = (dataString) => {
      if (!dataString) return null;
      const [dia, mes, ano] = dataString.split("/");
      return `${ano}/${mes.padStart(2, "0")}/${dia.padStart(2, "0")}`;
    };

    const opcoesDataCalendario = (date) => {
      const dataMinima = calcularDataMinima();
      if (!dataMinima) return true;

      dataMinima.setHours(0, 0, 0, 0);

      const [ano, mes, dia] = date.split("/");
      const dataCalendario = new Date(ano, mes - 1, dia);
      dataCalendario.setHours(0, 0, 0, 0);

      return dataCalendario >= dataMinima;
    };

    const alterarDadosAuxiliares = async (resultado) => {
      modalNecessidadeBase.value = false;
      if (resultado) {
        try {
          await store.dispatch("compras/alterarDadosAuxiliares", {
            uuid: id,
            data_aplicacao: dadosAuxiliaresBase?.value?.data_aplicacao
              ?.split("/")
              ?.reverse()
              ?.join("-"),
            detalhamento_tecnico:
              dadosAuxiliaresBase.value.detalhamento_tecnico,
            responsabilidades_fornecedores:
              dadosAuxiliaresBase.value.responsabilidades_fornecedores,
            responsabilidades_contratante:
              dadosAuxiliaresBase.value.responsabilidades_contratante,
            possiveis_fornecedores:
              dadosAuxiliaresBase.value.possiveis_fornecedores,
            justificativa_contratacao:
              dadosAuxiliaresBase.value.justificativa_contratacao,
          });

          $q.notify({
            message: "Dados auxiliares alterados com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        } catch (error) {
          $q.notify({
            message: `${error.response.data.message}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const enviarTemplate = async () => {
      if (file.value == "") {
        $q.notify({
          message: "O campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("compras/uploadAcompanhar", {
              arquivo: reader.result,
              uuid: id,
            });

            $q.notify({
              message: "Enviado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            getDados();
          } catch (error) {
            $q.notify({
              message: "Erro ao enviar",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    const getDocumentos = async () => {
      documentos.value = true;
      try {
        let response = await store.dispatch("compras/getArquivosAcompanhar", {
          uuid: id,
        });

        listaDocumentos.value = response.data.result.data;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar documentos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watchDebounced(
      () => dados.value?.cod_integracao,
      () => {
        if (dados.value?.cod_integracao != "") {
          setScNumero();
        }
      },
      { debounce: 800, immediate: false }
    );

    watchDebounced(
      () => dados.value?.observacao,
      () => {
        setScNumero();
      },
      { debounce: 800, immediate: false }
    );

    return {
      dados,
      getDados,
      rows,
      disable,
      info,
      file,
      enviarTemplate,
      getDocumentos,
      listaDocumentos,
      documentos,
      setScNumero,
      produtosSemReferencia,
      deletar,
      editar,
      rota,
      itens,
      getSemReferencia,
      atualizar,
      get,
      editarCabecalho,
      confirmarEdicaoCabecalho,
      historicoDialog,
      historicoCarregando,
      historicoItens,
      historicoErro,
      abrirHistoricoNecessidade,
      formatarData,
      columnsHistorico,
      modalNecessidade,
      dadosAuxiliares,
      inserirDados,
      modalNecessidadeBase,
      dadosAuxiliaresBase,
      alterarDadosAuxiliares,
      validarDataAplicacao,
      converterDataParaQDate,
      opcoesDataCalendario,
      calcularDataMaxima,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style>
.align {
  align-items: center;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}

tbody tr td {
  white-space: pre-wrap;
}

a {
  text-decoration: none;
}

.container-link-voltar {
  margin-right: 10px;
}

.icon-voltar {
  font-size: 25px;
}

.texto-titulo {
  font-size: 20px;
}

.modal-ativos {
  min-width: 1200px;
  max-width: 90vw;
}

.my-sticky-dynamic-ativo {
  max-height: 300px;
}

.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}

thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}

.expansion-row {
  background-color: #f9f9f9;
}

@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }

  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }

  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }

  .modal-ativos {
    min-width: 95vw;
  }
}
</style>
